export const EXPIRED_TOKEN_ERROR = 'JWT token is expired';

// The worker answers with the bare message, while the accounting gateway
// wraps it as { error: { message } } when proxying the conversion.
export const isExpiredTokenError = (error: unknown) => {
  const responseData = (error as { response?: { data?: unknown } })?.response
    ?.data;

  if (responseData === EXPIRED_TOKEN_ERROR) {
    return true;
  }

  const message = (responseData as { error?: { message?: unknown } })?.error
    ?.message;

  return typeof message === 'string' && message.includes(EXPIRED_TOKEN_ERROR);
};
